const companiesKeys = {
  module: ['companies'] as const,
  list: () => [...companiesKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...companiesKeys.list(), filters] as const,
  details: (id: string) => [...companiesKeys.module, 'details', id] as const,
  accessControls: (companyId: string) =>
    [...companiesKeys.module, 'access-controls', companyId] as const,
  relatedCompanies: (id: string) =>
    [...companiesKeys.module, 'related-companies', id] as const,
  distances: (companyId: string) =>
    [...companiesKeys.module, 'distances', companyId] as const,
  neighborhoodPrices: (companyId: string) =>
    [...companiesKeys.module, 'neighborhood-prices', companyId] as const,
  paymentMethods: (companyId: string) =>
    [...companiesKeys.module, 'payment-methods', companyId] as const,
};

export default companiesKeys;
